import EN from "../../locales/en";
import ErrorIcon from "../icons/ErrorIcon";
import Input from "../Input";
import Tabs from "../Tabs";

const EditEnergyConsumption = ({
  formik,
  handleFrequencyChange,
  FuelTypeMapping,
  frequency,
}) => {
  const frequencyOptions = [
    {
      id: "monthly",
      name: EN.edit_tariff_form.usage.frequency.options.monthly,
      current: frequency === "monthly",
    },
    {
      id: "annually",
      name: EN.edit_tariff_form.usage.frequency.options.annually,
      current: frequency === "annually",
    },
  ];

  const electricityTariff = formik.values.tariffs?.[0];
  const gasTariff = formik.values.tariffs?.[1];

  return (
    <>
      <div className="border-t border-[#afb6b9] pt-6">
        <h3 className="text-[22px] font-bold">
          {EN.edit_tariff_form.usage.title}
        </h3>
        <div className="mt-6">
          <label
            htmlFor="frequency"
            className="block text-md font-bold leading-[1.5] mb-1"
          >
            {EN.edit_tariff_form.usage.frequency.title}
          </label>
          <Tabs
            tabs={frequencyOptions}
            setCurrentTab={(e) => {
              handleFrequencyChange(e);
              const conversionFactor = e === "monthly" ? 1 / 12 : 12;
              formik.setFieldValue(`tariffs.0.estimatedUsage.unit`, e);
              formik.setFieldValue(`tariffs.1.estimatedUsage.unit`, e);
              formik.setFieldValue(
                `tariffs.0.estimatedUsage.value`,
                (
                  electricityTariff?.estimatedUsage?.value * conversionFactor
                ).toFixed(2)
              );
              formik.setFieldValue(
                `tariffs.1.estimatedUsage.value`,
                (gasTariff?.estimatedUsage?.value * conversionFactor).toFixed(2)
              );
            }}
            align="left"
            size="small"
          />
        </div>
      </div>

      {formik.values.fuelTypes &&
        FuelTypeMapping[formik.values.fuelTypes].map((fuelType) => {
          const index = fuelType === "electricity" ? 0 : 1;
          const currentTariff = formik.values.tariffs?.[index];
          const currentTariffErrors = formik.errors.tariffs?.[index];
          return (
            <div key={`${fuelType}-${index}`} className="space-y-6">
              <Input
                name={`${fuelType}Usage`}
                id={`${fuelType}-usage`}
                labelText={EN.edit_tariff_form.usage[fuelType][frequency].label}
                type="number"
                placeholder={
                  EN.edit_tariff_form.usage[fuelType][frequency].placeholder
                }
                value={currentTariff?.estimatedUsage?.value}
                onChange={(e) => {
                  formik.setFieldValue(
                    `tariffs.${index}.estimatedUsage.unit`,
                    frequency
                  );
                  formik.setFieldValue(
                    `tariffs.${index}.estimatedUsage.value`,
                    e.target.value
                  );
                }}
                appendText="kWh"
                hasErrors={currentTariffErrors?.estimatedUsage?.value}
                min={0}
                max={1000000}
                step="any"
                disabled={formik.isSubmitting}
              />
              {currentTariffErrors?.estimatedUsage?.value && (
                <div className="mt-3 flex justify-start items-start">
                  <ErrorIcon />
                  <p className="flex-1 text-red-500 text-sm">
                    {currentTariffErrors?.estimatedUsage?.value}
                  </p>
                </div>
              )}
            </div>
          );
        })}
    </>
  );
};

export default EditEnergyConsumption;
